/* eslint-disable */
<template>
  <div class="qc-page plan-dense-page qy-material-manage-page">
    <!-- Hero / Header Section -->
    <div class="qc-page__hero" style="margin-bottom: 16px;">
      <div>
        <div class="qc-page__eyebrow">千川全域 / 素材管理</div>
        <h1 class="qc-page__title">巨量引擎统一素材库</h1>
        <p class="qc-page__desc">
          基于巨量引擎官方 SDK 接口，支持广告主素材同步、图片/视频受控直传、智能属性与质量评估、短效 URL 快照及状态追踪。
        </p>
      </div>
    </div>

    <!-- Toolbar Operation Area -->
    <div class="dc-toolbar">
      <div class="dc-toolbar__actions">
        <el-button type="primary" icon="el-icon-search" size="small" :loading="loading" @click="loadMaterials">查询素材</el-button>
        <el-button type="primary" plain icon="el-icon-upload2" size="small" :disabled="!advertiserId" @click="openUploadDialog">上传素材</el-button>
        <el-button plain icon="el-icon-time" size="small" :disabled="!advertiserId" @click="openUploadTaskDialog">上传任务</el-button>
        <el-button type="success" icon="el-icon-refresh" size="small" :loading="syncing" @click="openMaterialSyncDialog">同步当前素材类型</el-button>
        <el-button type="warning" icon="el-icon-refresh" size="small" :loading="syncing" :disabled="materialType !== 'VIDEO'" @click="syncMaterialDetails">重补全视频详情与属性</el-button>
        <el-button type="success" plain icon="el-icon-refresh" size="small" :loading="syncing" @click="syncImages">同步官方图片</el-button>
        <el-tag v-if="syncJobNo" size="small" :type="syncTagType" class="sync-status-tag">{{ syncStatusText }}</el-tag>
      </div>

      <!-- Layout Mode Switch (Grid / Table) -->
      <div class="dc-toolbar__right">
        <el-radio-group v-model="layoutMode" size="small">
          <el-radio-button label="grid"><i class="el-icon-grid"></i> 网格</el-radio-button>
          <el-radio-button label="table"><i class="el-icon-tickets"></i> 列表</el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <!-- Filter Bar (Light Blue Modern Style) -->
    <div class="dc-filter-bar">
      <el-form :inline="true" size="small" class="dc-filter-form">
        <el-form-item label="广告主">
          <el-select
            v-model="advertiserId"
            filterable
            remote
            clearable
            :remote-method="searchAdvertisers"
            :loading="advertiserLoading"
            popper-class="material-library-advertiser-select"
            @visible-change="handleAdvertiserVisible"
            @change="handleAdvertiserChange"
            placeholder="请选择广告主（名称 / ID）"
            style="width: 240px;"
          >
            <el-option
              v-for="advertiser in advertiserOptions"
              :key="advertiser.advertiserIdValue"
              :label="advertiser.label || advertiser.advertiserId"
              :value="advertiser.advertiserIdValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="素材类型">
          <el-select v-model="materialType" clearable placeholder="全部素材类型" style="width: 140px;" @change="handleMaterialTypeChange">
            <el-option label="图片" value="IMAGE" />
            <el-option label="图文" value="CAROUSEL" />
            <el-option label="直播间画面" value="LIVE_ROOM" />
            <el-option label="标题" value="TITLE" />
            <el-option label="视频" value="VIDEO" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="materialType === 'VIDEO' || materialType === 'IMAGE' || materialType === 'CAROUSEL'" label="来源">
          <el-select v-model="materialSource" clearable placeholder="全部来源" style="width: 150px;" @change="handleFilterChange">
            <el-option v-for="item in sourceOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="materialType === 'VIDEO' || materialType === 'CAROUSEL'" label="素材渠道">
          <el-select v-model="materialChannel" clearable placeholder="全部素材渠道" style="width: 150px;" @change="handleFilterChange">
            <el-option v-if="materialType === 'VIDEO'" label="千川视频素材" value="QIANCHUAN_VIDEO" />
            <el-option v-if="materialType === 'VIDEO'" label="抖音视频素材" value="DOUYIN_VIDEO" />
            <el-option v-if="materialType === 'CAROUSEL'" label="千川图文素材" value="QIANCHUAN_CAROUSEL" />
            <el-option v-if="materialType === 'CAROUSEL'" label="抖音图文素材" value="DOUYIN_CAROUSEL" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="materialType === 'VIDEO' || materialType === 'IMAGE'" label="细分类型">
          <el-select v-model="materialSubtype" clearable placeholder="全部类型" style="width: 140px;" @change="handleFilterChange">
            <el-option v-for="item in subtypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="materialType === 'VIDEO'" label="素材评估">
          <el-select v-model="materialEvaluation" clearable placeholder="全部评估" style="width: 130px;" @change="handleFilterChange">
            <el-option label="优质素材" value="HIGH_QUALITY" />
            <el-option label="低质素材" value="LOW_QUALITY" />
            <el-option label="首发素材" value="FIRST_PUBLISH" />
            <el-option label="搬运素材" value="REPOST" />
            <el-option label="普通素材" value="NORMAL" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="materialType === 'VIDEO'" label="抖音号">
          <el-select v-model="selectedAwemeId" clearable filterable :loading="awemeLoading"
            placeholder="全部抖音号视频" style="width: 170px;" @change="handleAwemeIdChange">
            <el-option v-for="aweme in awemeOptions" :key="aweme.id" :label="aweme.label" :value="aweme.id" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- Main Section: Materials Container -->
    <div class="dc-section-card" v-loading="loading">

      <!-- 1. GRID VIEW MODE -->
      <template v-if="layoutMode === 'grid'">
        <div v-if="materials.length > 0" class="material-grid">
          <div v-for="item in materials" :key="item.id || item.materialId" class="material-grid-card">
            <!-- Cover Box & Hover Actions -->
            <div class="material-grid-card__cover" @click="openPreview(item)">
              <template v-if="isVideoRow(item)">
                <img v-if="hasVideoCover(item)" :src="videoCoverUrl(item)" class="cover-img" @error="handleVideoCoverLoadError(item)" />
                <div v-else class="empty-cover"><i class="el-icon-video-camera"></i><span>暂无封面</span></div>
                <div class="play-icon-overlay"><i class="el-icon-video-play"></i></div>
                <span v-if="item.durationMillis" class="duration-badge">{{ formatDuration(item.durationMillis) }}</span>
              </template>
              <template v-else-if="item.contentUrl && !shouldSkipPreviewSync(item)">
                <img :src="item.contentUrl" class="cover-img" @error="handlePreviewError(item)" />
              </template>
              <template v-else-if="shouldSkipPreviewSync(item)">
                <div class="empty-cover blocked">
                  <span>主体限制无法预览</span>
                  <el-button type="warning" size="mini" circle plain class="help-btn" @click.stop="openSensitiveAuthorizationGuide">?</el-button>
                </div>
              </template>
              <template v-else>
                <div class="empty-cover"><span>暂无预览</span></div>
              </template>

              <!-- Hover Overlays -->
              <div class="card-overlay">
                <el-button type="primary" size="mini" circle icon="el-icon-view" title="预览" @click.stop="openPreview(item)"></el-button>
                <el-button type="info" size="mini" circle icon="el-icon-info" title="详情" @click.stop="openMaterialDetail(item)"></el-button>
                <el-button v-if="isImageRow(item)" type="success" size="mini" circle icon="el-icon-refresh" title="刷新预览" @click.stop="refreshUrl(item)"></el-button>
              </div>
            </div>

            <!-- Card Info Footer -->
            <div class="material-grid-card__info">
              <div class="title-line truncate" :title="item.filename || item.materialId">
                {{ item.filename || '未命名素材' }}
              </div>
              <div class="meta-line">
                <span class="sub-text">ID: {{ item.materialId || '-' }}</span>
                <span class="type-tag">{{ materialTypeText(item.materialType) }}</span>
              </div>
              <div class="tags-line">
                <el-tag size="mini" :type="qualityType(item.qualityLevel)">{{ qualityText(item.qualityLevel) }}</el-tag>
                <template v-if="isQianchuanVideoRow(item)">
                  <el-tag v-for="tag in classificationTagItems(item)" :key="tag" :type="classificationTagType(tag)" size="mini">
                    {{ classificationTagText(tag) }}
                  </el-tag>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="dc-empty-wrap">
          <i class="el-icon-folder-opened" style="font-size: 40px; color: #94a3b8;"></i>
          <p style="margin-top: 8px; color: #64748b;">请选择广告主并点击“查询素材”或“同步当前素材类型”</p>
        </div>
      </template>

      <!-- 2. TABLE VIEW MODE (Ultra-compact Table) -->
      <template v-else>
        <el-table :data="materials" size="small" border stripe class="dc-compact-table">
          <el-table-column label="预览" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="isVideoRow(scope.row)" class="table-preview-box" @click="openPreview(scope.row)">
                <img v-if="hasVideoCover(scope.row)" :src="videoCoverUrl(scope.row)" class="table-thumb" @error="handleVideoCoverLoadError(scope.row)" />
                <div v-else class="table-thumb-empty"><i class="el-icon-video-camera"></i></div>
                <i class="el-icon-video-play table-play-overlay"></i>
              </div>
              <img v-else-if="scope.row.contentUrl && !shouldSkipPreviewSync(scope.row)" :src="scope.row.contentUrl" class="table-thumb" @click="openPreview(scope.row)" @error="handlePreviewError(scope.row)" />
              <span v-else-if="shouldSkipPreviewSync(scope.row)" class="table-blocked-text">
                主体限制
                <el-button type="warning" size="mini" circle plain style="padding: 2px 4px; font-size: 10px;" @click="openSensitiveAuthorizationGuide">?</el-button>
              </span>
              <span v-else class="sub-text">无预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="filename" label="素材名称" min-width="180" show-overflow-tooltip />
          <el-table-column prop="materialId" label="官方素材ID" width="140" />
          <el-table-column label="类型" width="90">
            <template slot-scope="scope">{{ materialTypeText(scope.row.materialType) }}</template>
          </el-table-column>
          <el-table-column label="来源" min-width="130" show-overflow-tooltip>
            <template slot-scope="scope">{{ materialSourceText(scope.row.materialSource) }}</template>
          </el-table-column>
          <el-table-column label="渠道来源" width="130">
            <template slot-scope="scope">{{ materialChannelText(scope.row.materialChannel) }}</template>
          </el-table-column>
          <el-table-column v-if="showMaterialSubtypeColumn" label="细分类型" width="110">
            <template slot-scope="scope">{{ materialSubtypeText(scope.row.materialSubtype) }}</template>
          </el-table-column>
          <el-table-column v-if="showVideoColumn" label="视频" width="130">
            <template slot-scope="scope">
              <div class="video-cell">
                <span>{{ scope.row.durationMillis ? formatDuration(scope.row.durationMillis) : '-' }}</span>
                <el-button type="text" size="mini" :disabled="!canOpenVideoPageForRow(scope.row)" @click="openVideoPage(scope.row)">打开页面</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="素材评估" min-width="130">
            <template slot-scope="scope">
              <template v-if="isQianchuanVideoRow(scope.row)">
                <el-tag v-for="tag in classificationTagItems(scope.row)" :key="tag" :type="classificationTagType(tag)" size="mini" style="margin-right: 4px;">
                  {{ classificationTagText(tag) }}
                </el-tag>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="质量" width="125">
            <template slot-scope="scope"><el-tag size="mini" :type="qualityType(scope.row.qualityLevel)">{{ qualityText(scope.row.qualityLevel) }}</el-tag></template>
          </el-table-column>
          <el-table-column label="素材状态" width="100">
            <template slot-scope="scope">{{ materialSyncStateText(scope.row.syncState) }}</template>
          </el-table-column>
          <el-table-column prop="lastSyncedAt" label="最近同步" width="160" />
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openMaterialDetail(scope.row)">详情</el-button>
              <el-button v-if="isImageRow(scope.row)" type="text" size="mini" @click="refreshUrl(scope.row)">刷新预览</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="pageIndex"
          :page-size.sync="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          @current-change="loadMaterials"
          @size-change="handleSizeChange"
        />
      </div>
    </div>

    <!-- DIALOG 1: Upload Material Dialog -->
    <el-dialog title="上传素材到巨量引擎" :visible.sync="uploadDialogVisible" width="560px" append-to-body @closed="resetUploadForm">
      <el-alert
        title="提交后会真实创建巨量引擎素材；图片和视频均使用官方文件直传，并通过上传任务状态轮询结果。"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 16px;"
      />
      <el-form :model="uploadForm" label-width="110px" size="small">
        <el-form-item label="广告主"><span>{{ advertiserId || '-' }}</span></el-form-item>
        <el-form-item label="素材类型" required>
          <el-radio-group v-model="uploadForm.materialType" @change="handleUploadMaterialTypeChange">
            <el-radio label="IMAGE">图片</el-radio>
            <el-radio label="VIDEO">视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="uploadForm.materialType === 'IMAGE'" label="投放规格" required>
          <el-select v-model="uploadForm.materialSpec" placeholder="请选择图片规格" style="width: 100%;">
            <el-option v-for="spec in imageMaterialSpecs" :key="spec.code" :label="spec.label" :value="spec.code" />
          </el-select>
          <div class="sub-tip">{{ imageMaterialSpecTip(uploadForm.materialSpec) }}；选择图片后可调整画面。</div>
        </el-form-item>
        <el-form-item v-if="uploadForm.materialType === 'VIDEO'" label="上传方式">
          <el-tag type="success" size="small">官方文件直传</el-tag>
          <div class="sub-tip">视频将安全提交至巨量引擎，可在“上传任务”中查看进度与结果。</div>
        </el-form-item>
        <el-form-item v-if="uploadForm.materialType === 'VIDEO'" label="视频规格" required>
          <el-select v-model="uploadForm.videoSpec" placeholder="选择视频后自动识别" style="width: 100%;" :disabled="Boolean(uploadForm.file)">
            <el-option v-for="spec in videoMaterialSpecs" :key="spec.code" :label="spec.label" :value="spec.code" />
          </el-select>
          <div class="sub-tip">选择视频后自动识别横/竖版；{{ videoMaterialSpecTip(uploadForm.videoSpec) }}</div>
        </el-form-item>
        <el-form-item label="选择文件" required>
          <el-upload action="#" :auto-upload="false" :limit="1" :file-list="uploadFileList"
            :on-change="handleUploadFileChange" :on-remove="handleUploadFileRemove" :before-upload="beforeUploadFile">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">图片与视频文件仅提交至本后台后由后端安全调用官方 SDK 直传。视频时长范围：300s≥时长≥4s。</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="AI 生成素材">
          <el-switch v-model="uploadForm.isAigc" active-text="是" inactive-text="否" />
        </el-form-item>
        <template v-if="uploadForm.materialType === 'VIDEO'">
          <el-form-item label="引导视频">
            <el-switch v-model="uploadForm.isGuideVideo" active-text="是" inactive-text="否" />
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer">
        <el-button :disabled="uploading" @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="uploading" @click="submitUpload">确认上传</el-button>
      </span>
    </el-dialog>

    <!-- DIALOG 2: Image Crop Dialog (Canvas Based) -->
    <el-dialog title="裁剪优化" :visible.sync="imageCropVisible" width="760px" append-to-body @closed="closeImageCropDialog">
      <el-radio-group v-model="imageCropSpecCode" size="small" style="margin-bottom: 12px;">
        <el-radio-button v-for="spec in imageMaterialSpecs" :key="spec.code" :label="spec.code">{{ spec.label }}</el-radio-button>
      </el-radio-group>
      <div class="image-crop-preview-box" v-loading="imageCropGenerating">
        <img v-if="imageCropObjectUrl" :src="imageCropObjectUrl" alt="待裁切图片" class="crop-img-element" />
      </div>
      <div class="sub-tip" style="margin-top: 10px;">确认后将按目标规格 ({{ imageCropRatioText }}) 自动进行智能裁剪与格式优化，导出文件不超过 1.5M。</div>
      <span slot="footer">
        <el-button :disabled="imageCropGenerating" @click="cancelImageCrop">取消</el-button>
        <el-button type="primary" :loading="imageCropGenerating" @click="confirmImageCrop">确认裁切</el-button>
      </span>
    </el-dialog>

    <!-- DIALOG 3: Upload Task Management Dialog -->
    <el-dialog title="素材上传任务" :visible.sync="uploadTaskDialogVisible" width="1000px" append-to-body @closed="clearUploadTaskListPolling">
      <div class="task-guide-bar">
        <i class="el-icon-refresh" style="color: #3b82f6;"></i>
        <span>任务状态会自动实时更新；若任务失败可根据失败原因点击重试。</span>
      </div>
      <div class="task-toolbar">
        <div class="task-stats">
          <el-tag size="small" type="warning">处理中 {{ uploadTaskStats.processing }}</el-tag>
          <el-tag size="small" type="success" style="margin-left: 6px;">成功 {{ uploadTaskStats.success }}</el-tag>
          <el-tag size="small" type="danger" style="margin-left: 6px;">失败 {{ uploadTaskStats.failed }}</el-tag>
        </div>
        <el-button size="mini" icon="el-icon-refresh" :loading="uploadTasksLoading" @click="loadUploadTasks">刷新状态</el-button>
      </div>
      <el-table :data="uploadTasks" v-loading="uploadTasksLoading" size="mini" border stripe style="margin-top: 12px">
        <el-table-column prop="uploadTaskId" label="本地ID" width="80" />
        <el-table-column prop="filename" label="文件名" min-width="140" show-overflow-tooltip />
        <el-table-column label="类型" width="100"><template slot-scope="scope">{{ uploadTypeText(scope.row.uploadType) }}</template></el-table-column>
        <el-table-column label="规格" width="110"><template slot-scope="scope">{{ uploadMaterialSpecText(scope.row.materialSpec) }}</template></el-table-column>
        <el-table-column label="状态" width="110"><template slot-scope="scope"><el-tag size="mini" :type="uploadStateTagType(scope.row.state)">{{ uploadStateText(scope.row.state) }}</el-tag></template></el-table-column>
        <el-table-column prop="attemptCount" label="尝试" width="60" />
        <el-table-column prop="officialFileId" label="官方文件ID" width="130" show-overflow-tooltip />
        <el-table-column prop="materialId" label="官方素材ID" width="130" show-overflow-tooltip />
        <el-table-column prop="lastErrorMessage" label="失败原因" min-width="160" show-overflow-tooltip />
        <el-table-column prop="updateTime" label="更新时间" width="150" />
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="canRetryUploadTask(scope.row)" type="text" size="mini" :loading="retryingUploadTaskId === scope.row.uploadTaskId" @click="retryUploadTask(scope.row)">重试</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- DIALOG 4: Readonly Material Sync Dialog -->
    <el-dialog title="同步官方素材" :visible.sync="syncMaterialDialogVisible" width="560px" append-to-body>
      <el-alert type="info" :closable="false" title="仅查询并保存官方素材；不会修改或删除巨量引擎远端数据。" show-icon style="margin-bottom: 14px;" />
      <el-form :model="syncMaterialForm" label-width="100px" size="small">
        <el-form-item label="素材类型" required>
          <el-select v-model="syncMaterialForm.materialType" placeholder="请选择素材类型" style="width: 100%;" @change="handleSyncMaterialTypeChange">
            <el-option label="图片" value="IMAGE" />
            <el-option label="图文" value="CAROUSEL" />
            <el-option label="直播间画面" value="LIVE_ROOM" />
            <el-option label="标题" value="TITLE" />
            <el-option label="视频" value="VIDEO" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="syncMaterialForm.materialType === 'VIDEO'" label="抖音号">
          <el-select v-model="syncMaterialForm.awemeId" clearable filterable :loading="awemeLoading"
            placeholder="留空则同步账户视频素材" style="width: 100%;">
            <el-option v-for="aweme in awemeOptions" :key="aweme.id" :label="aweme.label" :value="aweme.id" />
          </el-select>
          <div class="sub-tip">选择后仅同步该抖音号的官方作品视频。</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="syncMaterialDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="syncing" @click="syncCurrentMaterialType">提交只读同步</el-button>
      </span>
    </el-dialog>

    <!-- DIALOG 5: Sensitive Authorization Notice -->
    <el-dialog title="素材预览授权说明" :visible.sync="sensitiveAuthorizationVisible" width="700px" append-to-body>
      <el-alert title="当前素材所属主体与开发者主体不一致，官方未返回预览 URL。" type="warning" :closable="false" show-icon />
      <div class="auth-guide-content">
        <p><strong>解决办法：</strong>请在巨量引擎重新发起广告主授权，并在授权页面勾选：</p>
        <p class="auth-highlight">“允许开发者管理敏感物料”</p>
        <a href="https://ad.oceanengine.com/athena/faq/index.html?plat_id=7&id=1675539226863629" target="_blank" class="auth-link">查看官方敏感物料授权 FAQ说明</a>
      </div>
    </el-dialog>

    <!-- DIALOG 6: Material Preview Dialog -->
    <el-dialog title="素材预览" :visible.sync="previewVisible" width="700px" append-to-body>
      <div v-if="previewMaterial" class="preview-dialog-body">
        <div class="preview-media-wrap">
          <img v-if="isVideoMaterial && videoCoverUrl(previewMaterial) && !videoCoverUnavailable" :src="videoCoverUrl(previewMaterial)" class="preview-img" @error="handleVideoCoverError" />
          <span v-else-if="isVideoMaterial" class="empty-text">{{ previewUnavailableText }}</span>
          <img v-else-if="previewMaterial.contentUrl && !shouldSkipPreviewSync(previewMaterial)" :src="previewMaterial.contentUrl" class="preview-img" @error="handlePreviewError(previewMaterial)" />
          <span v-else class="empty-text">{{ previewUnavailableText }}</span>
        </div>
        <div class="preview-meta-info">
          <p><strong>素材名称：</strong>{{ previewMaterial.filename || '-' }}</p>
          <p><strong>官方素材 ID：</strong>{{ previewMaterial.materialId || '-' }}</p>
          <p><strong>素材类型：</strong>{{ materialTypeText(previewMaterial.materialType) }}</p>
          <p v-if="isVideoMaterial && previewMaterial.durationMillis"><strong>视频时长：</strong>{{ formatDuration(previewMaterial.durationMillis) }}</p>
          <div v-if="isVideoMaterial" style="margin-top: 10px;">
            <el-button v-if="canOpenVideoPage" type="primary" size="mini" plain icon="el-icon-link" @click="openVideoPage(previewMaterial)">{{ videoOpenText }}</el-button>
            <div class="sub-tip" style="margin-top: 6px;">官方作品页地址不能直接用 HTML5 视频播放器播放；请点击上方链接进行新标签跳转查看。</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- DRAWER: Material Detail Drawer -->
    <el-drawer title="素材详情" :visible.sync="detailVisible" size="55%" append-to-body>
      <div v-loading="detailLoading" class="detail-drawer-content">
        <template v-if="materialDetail">
          <el-alert title="官方短期预览 URL 仅作临时快照，失效后可点击刷新预览。" type="info" :closable="false" show-icon style="margin-bottom: 16px;" />

          <!-- Basic Info -->
          <div class="detail-block">
            <h4>基础信息</h4>
            <div class="info-grid">
              <p><span>素材名称：</span>{{ materialDetail.filename || '-' }}</p>
              <p><span>官方素材 ID：</span>{{ materialDetail.materialId || '-' }}</p>
              <p v-if="isVideoDetail"><span>抖音号 ID：</span>{{ materialDetail.awemeId || '-' }}</p>
              <p v-if="isVideoDetail"><span>抖音作品 ID：</span>{{ materialDetail.awemeItemId || '-' }}</p>
              <p><span>类型：</span>{{ materialTypeText(materialDetail.materialType) }}</p>
              <p><span>最近同步：</span>{{ materialDetail.lastSyncedAt || '-' }}</p>
              <p v-if="isVideoDetail"><span>时长：</span>{{ formatDuration(materialDetail.durationMillis) }}</p>
              <p v-if="isVideoDetail"><span>分辨率：</span>{{ materialDetail.width || '-' }} × {{ materialDetail.height || '-' }}</p>
              <p v-if="isVideoDetail"><span>文件大小：</span>{{ formatFileSize(materialDetail.sizeBytes) }}</p>
              <p><span>数据来源：</span>{{ dataSourceText(materialDetail.dataSources) }}</p>
            </div>
          </div>

          <!-- URL Snapshots -->
          <div class="detail-block">
            <h4>URL 时效快照</h4>
            <el-table v-if="(materialDetail.urlSnapshots || []).length" :data="materialDetail.urlSnapshots" size="mini" border stripe>
              <el-table-column label="类型" width="90"><template slot-scope="scope">{{ urlKindText(scope.row.urlKind) }}</template></el-table-column>
              <el-table-column label="状态" width="100"><template slot-scope="scope">{{ urlStateText(scope.row.urlState) }}</template></el-table-column>
              <el-table-column prop="officialValidUntil" label="官方有效期" min-width="150" />
              <el-table-column prop="lastRefreshError" label="最近错误" min-width="160" show-overflow-tooltip />
            </el-table>
            <div v-else class="detail-empty">尚未获取官方预览地址</div>
          </div>

          <!-- Assessments -->
          <div class="detail-block">
            <h4>质量评估与低效原因</h4>
            <el-table v-if="(materialDetail.assessments || []).length" :data="materialDetail.assessments" size="mini" border stripe>
              <el-table-column label="评估类型" width="130"><template slot-scope="scope">{{ assessmentTypeText(scope.row.assessmentType) }}</template></el-table-column>
              <el-table-column label="等级" width="100"><template slot-scope="scope">{{ assessmentGradeText(scope.row.grade) }}</template></el-table-column>
              <el-table-column prop="reasonCode" label="原因码" width="120" />
              <el-table-column prop="reasonText" label="官方原因" min-width="180" show-overflow-tooltip />
              <el-table-column prop="sourceTime" label="官方时间" width="150" />
            </el-table>
            <div v-else class="detail-empty">{{ dataStatusText(materialDetail.assessmentDataStatus) }}</div>
          </div>

          <!-- Preaudits -->
          <div class="detail-block">
            <h4>预审记录</h4>
            <el-table v-if="(materialDetail.preaudits || []).length" :data="materialDetail.preaudits" size="mini" border stripe>
              <el-table-column prop="preauditId" label="预审 ID" width="130" />
              <el-table-column label="结果" width="100"><template slot-scope="scope">{{ preauditStatusText(scope.row.resultStatus) }}</template></el-table-column>
              <el-table-column prop="rejectCode" label="驳回码" width="120" />
              <el-table-column prop="rejectReason" label="官方原因" min-width="180" show-overflow-tooltip />
            </el-table>
            <div v-else class="detail-empty">{{ dataStatusText(materialDetail.preauditDataStatus) }}</div>
          </div>
        </template>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import request from '@/utils/axios'
import url from '@/utils/url'

export default {
  name: 'MaterialManage',
  data() {
    return {
      layoutMode: 'grid', // 'grid' | 'table'
      advertiserId: '',
      advertiserOptions: [],
      advertiserLoading: false,
      advertiserSearchKeyword: '',
      advertiserPageIndex: 1,
      advertiserHasMore: true,
      advertiserRequesting: false,
      advertiserRequestId: 0,
      advertiserSearchTimer: null,
      advertiserScrollWrap: null,
      advertiserScrollHandler: null,
      selectedAwemeId: '',
      awemeOptions: [],
      awemeLoading: false,
      materialType: '',
      materialSource: '',
      materialChannel: '',
      materialSubtype: '',
      materialEvaluation: '',
      materials: [],
      loading: false,
      syncing: false,
      syncMaterialDialogVisible: false,
      uploadDialogVisible: false,
      uploadTaskDialogVisible: false,
      uploadTasksLoading: false,
      uploadTasks: [],
      uploadTaskListPollTimer: null,
      uploadTaskListPollCount: 0,
      retryingUploadTaskId: null,
      uploading: false,
      uploadFileList: [],
      imageCropVisible: false,
      imageCropObjectUrl: '',
      imageCropSpecCode: 'LARGE',
      pendingImageCropFile: null,
      imageCropGenerating: false,
      imageMaterialSpecs: [
        { code: 'LARGE', label: '横版大图', ratioWidth: 16, ratioHeight: 9, minWidth: 1280, minHeight: 720, maxWidth: 2560, maxHeight: 1440, sourceMaxBytes: 10485760 },
        { code: 'LARGE_VERTICAL', label: '竖版大图', ratioWidth: 9, ratioHeight: 16, minWidth: 1080, minHeight: 1920, maxWidth: 2160, maxHeight: 3840, sourceMaxBytes: 10485760 },
        { code: 'SMALL', label: '横版小图', ratioWidth: 38, ratioHeight: 25, minWidth: 456, minHeight: 300, maxWidth: 1368, maxHeight: 900, sourceMaxBytes: 10485760 },
        { code: 'SQUARE', label: '商品卡方图', ratioWidth: 1, ratioHeight: 1, minWidth: 600, minHeight: 600, maxWidth: 3000, maxHeight: 3000, sourceMaxBytes: 10485760 },
        { code: 'PRODUCT_VERTICAL', label: '商品卡竖图', ratioWidth: 3, ratioHeight: 4, minWidth: 600, minHeight: 800, maxWidth: 3000, maxHeight: 4000, sourceMaxBytes: 5242880 }
      ],
      videoMaterialSpecs: [
        { code: 'VIDEO_HORIZONTAL', label: '横版视频', ratioWidth: 16, ratioHeight: 9, minWidth: 1280, minHeight: 720, maxWidth: 2560, maxHeight: 1440 },
        { code: 'VIDEO_VERTICAL', label: '竖版视频', ratioWidth: 9, ratioHeight: 16, minWidth: 720, minHeight: 1280, maxWidth: 1440, maxHeight: 2560 }
      ],
      uploadPollTimer: null,
      uploadPollCount: 0,
      maxUploadPollCount: 300,
      uploadForm: {
        materialType: 'IMAGE',
        uploadMode: 'DIRECT_FILE',
        materialSpec: 'LARGE',
        videoSpec: 'VIDEO_HORIZONTAL',
        file: null,
        isAigc: false,
        isGuideVideo: false,
        labels: ''
      },
      syncMaterialForm: {
        materialType: '',
        marketingGoal: 'VIDEO_PROM_GOODS',
        marketingScene: 'FEED',
        awemeId: '',
        timeMode: 'PRESET',
        timePreset: '30',
        timeRange: []
      },
      syncJobNo: '',
      syncState: '',
      syncPhase: '',
      syncPageCount: 0,
      syncSuccessCount: 0,
      syncFailureCount: 0,
      syncPollTimer: null,
      syncPollCount: 0,
      maxSyncPollCount: 300,
      previewSyncPageKey: '',
      previewBlockedNoticePageKey: '',
      previewVisible: false,
      previewMaterial: null,
      videoCoverUnavailable: false,
      videoCoverUnavailableByMaterial: {},
      sensitiveAuthorizationVisible: false,
      detailVisible: false,
      detailLoading: false,
      materialDetail: null,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      refreshing: {}
    }
  },
  created() {
    this.loadAdvertiserOptions({ keyword: '', pageIndex: 1, append: false })
  },
  beforeDestroy() {
    this.clearAdvertiserSearchScroll()
    this.clearSyncPolling()
    this.clearUploadPolling()
    this.clearUploadTaskListPolling()
    if (this.imageCropObjectUrl) {
      window.URL.revokeObjectURL(this.imageCropObjectUrl)
    }
  },
  computed: {
    sourceOptions() {
      const options = {
        VIDEO: ['ARTHUR|亚瑟共享素材', 'CREATIVE_CENTER|巨量创意PC共享素材', 'E_COMMERCE|本地上传', 'LIVE_HIGHLIGHT|直播剪辑素材', 'STAR|星图&即合共享素材', 'TADA|tada共享素材', 'VIDEO_CAPTURE|易拍APP共享素材', 'AGENT|巨量方舟'],
        IMAGE: ['E_COMMERCE|本地上传', 'JI_CHUANG|即创共享素材'],
        CAROUSEL: ['E_COMMERCE|本地上传', 'JI_CHUANG|即创共享素材']
      }
      return (options[this.materialType] || []).map(item => { const values = item.split('|'); return { value: values[0], label: values[1] } })
    },
    subtypeOptions() {
      const options = {
        VIDEO: [{ value: 'VIDEO_HORIZONTAL', label: '横版视频' }, { value: 'VIDEO_VERTICAL', label: '竖版视频' }],
        IMAGE: [{ value: 'IMAGE_SMALL', label: '横版小图' }, { value: 'IMAGE_LARGE', label: '横版大图' }, { value: 'IMAGE_VERTICAL', label: '竖版图片' }, { value: 'IMAGE_PANORAMA_VERTICAL', label: '全景竖图' }, { value: 'IMAGE_SQUARE', label: '方图' }, { value: 'IMAGE_PRODUCT_SQUARE', label: '商品卡方图' }, { value: 'IMAGE_PRODUCT_VERTICAL', label: '商品卡竖图' }]
      }
      return options[this.materialType] || []
    },
    syncStatusText() {
      if (!this.syncJobNo) return ''
      if (this.syncState === 'SUCCESS') return '同步完成'
      if (this.syncState === 'FAILED') return '同步失败'
      if (this.syncPhase === 'VIDEO_CLASSIFICATION') return '正在批量同步低效与首发标签'
      if (this.syncPhase === 'ATTRIBUTE_ENRICH') return '正在批量补全素材属性'
      if (this.syncPhase === 'DETAIL_ENRICH') return '正在批量补全详情'
      if (this.syncState === 'RUNNING') return `同步中：已提交 ${this.syncSuccessCount || 0} 条（${this.syncPageCount || 0} 页）`
      return '排队中'
    },
    syncTagType() {
      if (this.syncState === 'SUCCESS') return 'success'
      if (this.syncState === 'FAILED') return 'danger'
      if (this.syncState === 'RUNNING') return 'warning'
      return 'info'
    },
    isVideoMaterial() {
      const type = this.previewMaterial && this.previewMaterial.materialType
      return String(type || '').toUpperCase().indexOf('VIDEO') >= 0
    },
    isVideoDetail() {
      const type = this.materialDetail && this.materialDetail.materialType
      return String(type || '').toUpperCase() === 'VIDEO'
    },
    showMaterialSubtypeColumn() {
      return this.materialType === 'IMAGE' || this.materialType === 'VIDEO'
    },
    showVideoColumn() {
      return this.materialType === 'VIDEO'
    },
    uploadTaskStats() {
      const stats = { processing: 0, success: 0, failed: 0 }
      ;(this.uploadTasks || []).forEach((task) => {
        if (task.state === 'SUCCESS') stats.success += 1
        else if (task.state === 'FAILED') stats.failed += 1
        else stats.processing += 1
      })
      return stats
    },
    canOpenVideoPage() {
      return this.isVideoMaterial && this.isSafeExternalUrl(this.previewMaterial && this.previewMaterial.contentUrl)
    },
    videoOpenText() {
      return this.previewMaterial && this.previewMaterial.awemeItemId ? '打开抖音作品' : '打开官方视频页面'
    },
    previewUnavailableText() {
      if (this.isVideoMaterial) {
        return this.videoCoverUnavailable ? '官方视频封面暂不可用' : '官方未返回视频封面'
      }
      return this.shouldSkipPreviewSync(this.previewMaterial) ? '素材所属主体与开发者主体不一致，无法获取 URL' : '暂无可用预览地址'
    },
    imageCropRatioText() {
      const spec = this.getImageMaterialSpec(this.imageCropSpecCode)
      return spec ? `${spec.label} (${spec.ratioWidth}:${spec.ratioHeight})` : '未知规格'
    },
    hasPendingUploadTasks() {
      return (this.uploadTasks || []).some((task) => task.state === 'UPLOADING' || task.state === 'OFFICIAL_PENDING')
    }
  },
  methods: {
    openUploadDialog() {
      if (!this.requireAdvertiser()) return
      this.resetUploadForm()
      this.uploadDialogVisible = true
    },
    resetUploadForm() {
      this.uploading = false
      this.uploadFileList = []
      this.uploadForm = {
        materialType: 'IMAGE', uploadMode: 'DIRECT_FILE', materialSpec: 'LARGE', videoSpec: 'VIDEO_HORIZONTAL', file: null,
        isAigc: false, isGuideVideo: false, labels: ''
      }
    },
    handleUploadMaterialTypeChange(materialType) {
      this.uploadForm.uploadMode = 'DIRECT_FILE'
      if (materialType === 'IMAGE') this.uploadForm.materialSpec = 'LARGE'
      if (materialType === 'VIDEO') this.uploadForm.videoSpec = 'VIDEO_HORIZONTAL'
      this.uploadFileList = []
      this.uploadForm.file = null
      this.closeImageCropDialog()
    },
    async handleUploadFileChange(file, fileList) {
      const rawFile = file && file.raw ? file.raw : null
      if (this.uploadForm.materialType !== 'IMAGE') {
        if (!rawFile || !(await this.validateVideoFile(rawFile))) {
          this.uploadForm.file = null
          this.uploadFileList = []
          return
        }
        this.uploadForm.file = rawFile
        this.uploadFileList = fileList || []
        return
      }
      if (!rawFile || !this.validateSourceImageFile(rawFile)) {
        this.uploadForm.file = null
        this.uploadFileList = []
        return
      }
      this.pendingImageCropFile = rawFile
      this.uploadForm.file = null
      this.uploadFileList = []
      this.openImageCropDialog(rawFile)
    },
    handleUploadFileRemove() {
      this.uploadForm.file = null
      this.uploadFileList = []
      this.closeImageCropDialog()
    },
    beforeUploadFile() { return false },
    getImageMaterialSpec(code) {
      return this.imageMaterialSpecs.find(item => item.code === code) || null
    },
    imageMaterialSpecTip(code) {
      const spec = this.getImageMaterialSpec(code)
      if (!spec) return '请选择图片规格'
      return `${spec.label}：${spec.ratioWidth}:${spec.ratioHeight}，${spec.minWidth}×${spec.minHeight} 至 ${spec.maxWidth}×${spec.maxHeight}`
    },
    getVideoMaterialSpec(code) {
      return this.videoMaterialSpecs.find(item => item.code === code) || null
    },
    detectVideoMaterialSpec(metadata) {
      if (!metadata || !metadata.width || !metadata.height) return null
      return this.videoMaterialSpecs.find(item => metadata.width * item.ratioHeight === metadata.height * item.ratioWidth) || null
    },
    videoMaterialSpecTip(code) {
      const spec = this.getVideoMaterialSpec(code)
      if (!spec) return '请选择视频规格'
        return `${spec.label}：${spec.ratioWidth}:${spec.ratioHeight}，${spec.minWidth}×${spec.minHeight} 至 ${spec.maxWidth}×${spec.maxHeight}，视频时长范围：300s≥时长≥4s，平均码率≥516kbps，文件≤1000M`
    },
    readVideoMetadata(file) {
      return new Promise((resolve, reject) => {
        const url = window.URL.createObjectURL(file)
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.onloadedmetadata = () => {
          const metadata = { width: video.videoWidth, height: video.videoHeight, duration: video.duration }
          window.URL.revokeObjectURL(url)
          resolve(metadata)
        }
        video.onerror = () => { window.URL.revokeObjectURL(url); reject(new Error('无法读取视频元数据')) }
        video.src = url
      })
    },
    async validateVideoFile(file) {
      if (!/^video\//i.test(file.type || '')) { this.$message.warning('视频素材只能选择视频文件'); return false }
      if (file.size > 1000 * 1024 * 1024) { this.$message.warning('视频文件不能超过1000M'); return false }
      try {
        const metadata = await this.readVideoMetadata(file)
        if (!metadata.width || !metadata.height || !metadata.duration) { this.$message.warning('无法读取视频分辨率或时长'); return false }
        const spec = this.detectVideoMaterialSpec(metadata)
        if (!spec) { this.$message.warning('视频比例仅支持16:9横版或9:16竖版，请更换视频文件'); return false }
        this.uploadForm.videoSpec = spec.code
        if (metadata.width < spec.minWidth || metadata.height < spec.minHeight || metadata.width > spec.maxWidth || metadata.height > spec.maxHeight) { this.$message.warning(`${spec.label}分辨率必须在${spec.minWidth}×${spec.minHeight}至${spec.maxWidth}×${spec.maxHeight}之间`); return false }
        if (metadata.duration < 4 || metadata.duration > 300) { this.$message.warning('无法上传，视频时长范围：300s≥时长≥4s'); return false }
        if (file.size * 8 / metadata.duration < 516 * 1024) { this.$message.warning('视频平均码率不能低于516kbps'); return false }
        this.$message.success(`已自动识别为${spec.label}`)
        return true
      } catch (error) { this.$message.warning('无法读取视频元数据，请更换可解析的视频文件'); return false }
    },
    validateSourceImageFile(file) {
      const spec = this.getImageMaterialSpec(this.uploadForm.materialSpec)
      const filename = String(file && file.name ? file.name : '').toLowerCase()
      if (!spec) { this.$message.warning('请先选择图片投放规格'); return false }
      if (!/\.(jpg|jpeg|png|bmp)$/.test(filename)) { this.$message.warning('图片仅支持 jpg、jpeg、png、bmp 格式'); return false }
      if (file.size > spec.sourceMaxBytes) { this.$message.warning(`${spec.label}原图不能超过 ${spec.sourceMaxBytes / 1024 / 1024}M`); return false }
      return true
    },
    openImageCropDialog(file) {
      if (this.imageCropObjectUrl) window.URL.revokeObjectURL(this.imageCropObjectUrl)
      this.imageCropSpecCode = this.uploadForm.materialSpec || 'LARGE'
      this.imageCropObjectUrl = window.URL.createObjectURL(file)
      this.imageCropVisible = true
    },
    closeImageCropDialog() {
      this.imageCropVisible = false
      if (this.imageCropObjectUrl) {
        window.URL.revokeObjectURL(this.imageCropObjectUrl)
        this.imageCropObjectUrl = ''
      }
    },
    cancelImageCrop() {
      this.closeImageCropDialog()
      this.uploadForm.file = null
      this.uploadFileList = []
      this.pendingImageCropFile = null
    },
    confirmImageCrop() {
      if (!this.pendingImageCropFile) return
      this.imageCropGenerating = true
      const spec = this.getImageMaterialSpec(this.imageCropSpecCode)
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const targetWidth = spec ? spec.minWidth : img.width
        const targetHeight = spec ? spec.minHeight : img.height
        canvas.width = targetWidth
        canvas.height = targetHeight
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, targetWidth, targetHeight)
        canvas.toBlob((blob) => {
          this.imageCropGenerating = false
          if (!blob) { this.$message.error('图形导出失败'); return }
          const file = new File([blob], this.pendingImageCropFile.name, { type: 'image/jpeg' })
          this.uploadForm.file = file
          this.uploadForm.materialSpec = this.imageCropSpecCode
          this.uploadFileList = [{ name: file.name, raw: file }]
          this.closeImageCropDialog()
          this.$message.success('裁剪与格式调整完成')
        }, 'image/jpeg', 0.9)
      }
      img.onerror = () => {
        this.imageCropGenerating = false
        this.$message.error('无法解析图片内容')
      }
      img.src = this.imageCropObjectUrl
    },
    createUploadRequestId() {
      return 'material-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10)
    },
    submitUpload() {
      if (!this.requireAdvertiser()) return
      const form = this.uploadForm
      const file = form.file
      if (!file) { this.$message.warning('请选择需要上传的文件'); return }
      if (form.materialType === 'IMAGE' && !this.getImageMaterialSpec(form.materialSpec)) {
        this.$message.warning('请选择图片投放规格并完成裁切'); return
      }
      if (form.materialType === 'IMAGE' && file.size > 1572864) {
        this.$message.warning('裁切后的图片不能超过官方 1.5M 限制'); return
      }
      const data = new FormData()
      data.append('advertiserId', this.advertiserId)
      data.append('clientRequestId', this.createUploadRequestId())
      data.append('file', file)
      data.append('isAigc', String(Boolean(form.isAigc)))
      let uploadUrl = '/oceanEngine/material/upload/image'
      if (form.materialType === 'VIDEO') {
        uploadUrl = '/oceanEngine/material/upload/video'
        data.append('uploadMode', form.uploadMode)
        data.append('videoSpec', form.videoSpec)
        data.append('isGuideVideo', String(Boolean(form.isGuideVideo)))
      } else {
        data.append('materialSpec', form.materialSpec)
      }
      this.$confirm('本次操作会真实上传素材到巨量引擎，确认继续吗？', '确认上传', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.uploading = true
        const baseUrl = url.reBase + '/trc20/qdd/manager'
        const sessionId = (this.$store && this.$store.state && this.$store.state.sessionId) || ''
        const xhr = new XMLHttpRequest()
        xhr.open('POST', baseUrl + uploadUrl)
        xhr.withCredentials = true
        if (sessionId) xhr.setRequestHeader('Authorization', sessionId)
        xhr.onload = () => {
          this.uploading = false
          try {
            const res = JSON.parse(xhr.responseText)
            if ((res.code === 0 || res.code === 1) && res.data) {
              this.uploadDialogVisible = false
              this.handleUploadTaskResponse(res.data)
            } else {
              this.$message.error(res.msg || '素材上传提交失败')
            }
          } catch (e) {
            this.$message.error('素材上传响应解析失败')
          }
        }
        xhr.onerror = () => {
          this.uploading = false
          this.$message.error('素材上传请求失败，请检查文件大小和网络后重试')
        }
        xhr.send(data)
      }).catch(() => { this.uploading = false })
    },
    handleUploadTaskResponse(task) {
      if (!task) return
      if (task.state === 'SUCCESS') {
        this.$message.success('素材已上传并写入本地素材库')
        this.loadMaterials()
        return
      }
      if (task.state === 'FAILED') {
        this.$message.error(task.lastErrorMessage || '素材上传失败')
        return
      }
      if (!task.clientRequestId) { this.$message.error('上传任务缺少客户端请求标识'); return }
      this.$message.success('上传任务已创建，正在处理')
      this.startUploadPolling(task.clientRequestId)
    },
    startUploadPolling(clientRequestId) {
      this.clearUploadPolling()
      this.uploadPollCount = 0
      this.pollUploadTask(clientRequestId)
      this.uploadPollTimer = setInterval(() => this.pollUploadTask(clientRequestId), 2000)
    },
    pollUploadTask(clientRequestId) {
      if (!clientRequestId || !this.advertiserId) return
      this.uploadPollCount += 1
      if (this.uploadPollCount > this.maxUploadPollCount) {
        this.clearUploadPolling()
        this.$message.warning('上传任务仍在处理中，请稍后在上传任务列表查看')
        return
      }
      request.get({
        url: '/oceanEngine/material/upload/task',
        data: { advertiserId: this.advertiserId, clientRequestId: clientRequestId },
        loading: false,
        success: (res) => {
          if ((res.code !== 0 && res.code !== 1) || !res.data) {
            this.clearUploadPolling()
            this.$message.error(res.msg || '上传任务查询失败')
            return
          }
          const task = res.data
          if (task.state === 'SUCCESS') {
            this.clearUploadPolling()
            this.$message.success('素材上传完成，已写入素材库')
            this.loadMaterials()
          } else if (task.state === 'FAILED') {
            this.clearUploadPolling()
            this.$message.error(task.lastErrorMessage || '素材上传失败')
          }
        },
        error: () => { this.clearUploadPolling(); this.$message.error('上传任务查询失败') }
      })
    },
    openUploadTaskDialog() {
      if (!this.requireAdvertiser()) return
      this.uploadTaskDialogVisible = true
      this.loadUploadTasks()
    },
    loadUploadTasks() {
      if (!this.advertiserId || this.uploadTasksLoading) return
      this.uploadTasksLoading = true
      request.get({
        url: '/oceanEngine/material/upload/tasks',
        data: { advertiserId: this.advertiserId },
        loading: false,
        success: (res) => {
          this.uploadTasksLoading = false
          if (res.code === 0 || res.code === 1) {
            this.uploadTasks = Array.isArray(res.data) ? res.data : []
            if (this.uploadTaskDialogVisible && this.hasPendingUploadTasks) this.startUploadTaskListPolling()
            else this.clearUploadTaskListPolling()
          } else {
            this.$message.error(res.msg || '上传任务获取失败')
          }
        },
        error: () => { this.uploadTasksLoading = false; this.$message.error('上传任务获取失败') }
      })
    },
    startUploadTaskListPolling() {
      if (this.uploadTaskListPollTimer || !this.uploadTaskDialogVisible || !this.hasPendingUploadTasks) return
      this.uploadTaskListPollCount = 0
      this.uploadTaskListPollTimer = setInterval(() => {
        this.uploadTaskListPollCount += 1
        if (!this.uploadTaskDialogVisible || !this.hasPendingUploadTasks || this.uploadTaskListPollCount > 180) {
          this.clearUploadTaskListPolling()
          return
        }
        this.loadUploadTasks()
      }, 10000)
    },
    clearUploadTaskListPolling() {
      if (this.uploadTaskListPollTimer) {
        clearInterval(this.uploadTaskListPollTimer)
        this.uploadTaskListPollTimer = null
      }
      this.uploadTaskListPollCount = 0
    },
    canRetryUploadTask(task) {
      return task && task.state === 'FAILED' && ['IMAGE_DIRECT', 'VIDEO_DIRECT'].includes(task.uploadType)
        && ['DIRECT_STAGING_FAILED', 'DIRECT_STAGING_INTERRUPTED'].indexOf(task.lastErrorCode) < 0
    },
    retryUploadTask(task) {
      if (!this.canRetryUploadTask(task) || this.retryingUploadTaskId) return
      this.$confirm('将复用已保存的受控文件源重新执行官方直传，可能在官方侧产生重复素材，确认重试吗？', '确认重试', { type: 'warning' }).then(() => {
        this.retryingUploadTaskId = task.uploadTaskId
        request.post({
          url: '/oceanEngine/material/upload/retry',
          data: { advertiserId: this.advertiserId, clientRequestId: task.clientRequestId },
          loading: false,
          success: (res) => {
            this.retryingUploadTaskId = null
            if ((res.code === 0 || res.code === 1) && res.data) {
              this.$message.success('上传任务已重新提交')
              this.loadUploadTasks()
              this.startUploadPolling(res.data.clientRequestId)
            } else { this.$message.error(res.msg || '上传任务重试失败') }
          },
          error: () => { this.retryingUploadTaskId = null; this.$message.error('上传任务重试失败') }
        })
      }).catch(() => {})
    },
    handleAdvertiserVisible(visible) {
      if (!visible) {
        return
      }
      if (!this.advertiserOptions.length || this.advertiserSearchKeyword) {
        this.loadAdvertiserOptions({
          keyword: '',
          pageIndex: 1,
          append: false,
          silent: !!this.advertiserOptions.length
        })
      }
      this.$nextTick(() => {
        this.bindAdvertiserSearchScroll()
      })
    },
    searchAdvertisers(query) {
      if (this.advertiserSearchTimer) {
        clearTimeout(this.advertiserSearchTimer)
      }
      this.advertiserSearchTimer = setTimeout(() => {
        this.advertiserSearchTimer = null
        this.loadAdvertiserOptions({
          keyword: query,
          pageIndex: 1,
          append: false
        })
      }, 200)
    },
    loadAdvertiserOptions(options) {
      const pageIndex = options && options.pageIndex ? options.pageIndex : 1
      const keyword = options && options.keyword ? String(options.keyword).trim() : ''
      const append = !!(options && options.append)
      const silent = !!(options && options.silent)
      this.advertiserRequestId += 1
      const requestId = this.advertiserRequestId
      this.advertiserRequesting = true
      this.advertiserLoading = !silent
      const requestData = {
        pageIndex,
        pageSize: 30
      }
      if (keyword) {
        requestData.keyword = keyword
      }
      request.post({
        url: '/oceanEngineAdvertiser/optionsByCondition',
        data: requestData,
        loading: false,
        success: (res) => {
          if (requestId !== this.advertiserRequestId) {
            return
          }
          this.advertiserRequesting = false
          this.advertiserLoading = false
          if (res.code !== 0 || !res.data) {
            return
          }
          const payload = res.data || {}
          const list = payload.content || payload.list || (Array.isArray(payload) ? payload : [])
          const nextOptions = (list || []).map(item => {
            const advertiserId = item && item.advertiserId !== undefined && item.advertiserId !== null
              ? String(item.advertiserId)
              : String(item.id || '')
            const name = item.name || item.advertiserName || ''
            return {
              advertiserIdValue: advertiserId,
              advertiserId: advertiserId,
              label: name ? `${name} (${advertiserId})` : advertiserId
            }
          }).filter(item => item.advertiserIdValue)
          this.advertiserSearchKeyword = keyword
          this.advertiserPageIndex = pageIndex
          this.advertiserHasMore = !!payload.hasMore
          this.advertiserOptions = append
            ? this.mergeAdvertiserOptions(this.advertiserOptions, nextOptions)
            : nextOptions
        },
        error: () => {
          if (requestId !== this.advertiserRequestId) {
            return
          }
          this.advertiserRequesting = false
          this.advertiserLoading = false
        }
      })
    },
    mergeAdvertiserOptions(existingOptions, nextOptions) {
      const mergedMap = {}
      const mergedOptions = []
      const options = []
        .concat(Array.isArray(existingOptions) ? existingOptions : [])
        .concat(Array.isArray(nextOptions) ? nextOptions : [])
      options.forEach((item) => {
        if (!item) {
          return
        }
        const optionKey = item.advertiserIdValue !== undefined && item.advertiserIdValue !== null
          ? String(item.advertiserIdValue)
          : ''
        if (!optionKey || mergedMap[optionKey]) {
          return
        }
        mergedMap[optionKey] = true
        mergedOptions.push(item)
      })
      return mergedOptions
    },
    loadMoreAdvertiserOptions() {
      if (this.advertiserRequesting || !this.advertiserHasMore) {
        return
      }
      this.loadAdvertiserOptions({
        keyword: this.advertiserSearchKeyword,
        pageIndex: this.advertiserPageIndex + 1,
        append: true,
        silent: true
      })
    },
    bindAdvertiserSearchScroll() {
      const tryBind = (attempts) => {
        const wrap = document.querySelector('.material-library-advertiser-select .el-select-dropdown__wrap')
        if (wrap) {
          if (this.advertiserScrollWrap === wrap && this.advertiserScrollHandler) {
            return
          }
          if (this.advertiserScrollWrap && this.advertiserScrollHandler) {
            this.advertiserScrollWrap.removeEventListener('scroll', this.advertiserScrollHandler)
          }
          this.advertiserScrollWrap = wrap
          this.advertiserScrollHandler = () => {
            if (wrap.scrollHeight - wrap.scrollTop <= wrap.clientHeight + 10) {
              this.loadMoreAdvertiserOptions()
            }
          }
          wrap.addEventListener('scroll', this.advertiserScrollHandler)
        } else if (attempts < 8) {
          setTimeout(() => tryBind(attempts + 1), 50)
        }
      }
      tryBind(0)
    },
    clearAdvertiserSearchScroll() {
      if (this.advertiserSearchTimer) {
        clearTimeout(this.advertiserSearchTimer)
        this.advertiserSearchTimer = null
      }
      if (this.advertiserScrollWrap && this.advertiserScrollHandler) {
        this.advertiserScrollWrap.removeEventListener('scroll', this.advertiserScrollHandler)
      }
      this.advertiserScrollWrap = null
      this.advertiserScrollHandler = null
    },
    handleAdvertiserChange() {
      this.selectedAwemeId = ''
      this.awemeOptions = []
      if (this.advertiserId) {
        this.loadAwemeOptions()
        this.loadMaterials()
      }
    },
    loadAwemeOptions() {
      if (!this.advertiserId) return
      this.awemeLoading = true
      request.get({
        url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.advertiserId,
        data: {},
        success: (res) => {
          this.awemeLoading = false
          if (res.code === 0 && res.data) {
            this.awemeOptions = (res.data || []).map((item) => {
              const id = item && item.id ? String(item.id) : ''
              const name = item && item.name ? item.name : '未命名抖音号'
              const showId = item && item.awemeShowId ? item.awemeShowId : ''
              return {
                id: id,
                label: showId ? `${name} (${showId})` : name
              }
            }).filter((item) => item.id)
          }
        },
        error: () => { this.awemeLoading = false }
      })
    },
    requireAdvertiser() {
      if (!this.advertiserId) {
        this.$message.warning('请先选择广告主')
        return false
      }
      return true
    },
    loadMaterials() {
      if (!this.requireAdvertiser()) return
      this.loading = true
      request.get({
        url: '/oceanEngine/material/listByCondition',
        data: {
          advertiserId: this.advertiserId,
          materialType: this.materialType,
          materialSource: this.materialSource,
          materialChannel: this.materialChannel,
          materialSubtype: this.materialSubtype,
          materialEvaluation: this.materialEvaluation,
          awemeId: this.selectedAwemeId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        },
        success: (res) => {
          this.loading = false
          if (res.code === 0 && res.data) {
            const page = res.data || {}
            const content = page.content || page.records || page.list || []
            this.materials = Array.isArray(content) ? content : []
            this.total = page.totalElements || page.total || page.totalCount || this.materials.length
          } else {
            this.materials = []
            this.total = 0
            this.$message.error(res.msg || '素材列表获取失败')
          }
        },
        error: () => {
          this.loading = false
          this.materials = []
          this.total = 0
          this.$message.error('素材列表获取失败')
        }
      })
    },
    handleMaterialTypeChange() {
      this.materialSource = ''
      this.materialChannel = ''
      this.materialSubtype = ''
      this.materialEvaluation = ''
      this.handleFilterChange()
    },
    handleFilterChange() {
      this.pageIndex = 1
      this.loadMaterials()
    },
    handleAwemeIdChange() {
      this.handleFilterChange()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadMaterials()
    },
    openMaterialSyncDialog() {
      if (!this.requireAdvertiser()) return
      if (!this.materialType) {
        this.$message.warning('请先在素材类型中选择需要同步的类型')
        return
      }
      this.syncMaterialForm.materialType = this.materialType
      this.syncMaterialForm.awemeId = this.materialType === 'VIDEO' ? this.selectedAwemeId : ''
      if (this.materialType === 'VIDEO') this.loadAwemeOptions()
      this.handleSyncMaterialTypeChange(this.materialType)
      this.syncMaterialDialogVisible = true
    },
    handleSyncMaterialTypeChange(materialType) {
      if (materialType === 'LIVE_ROOM') this.syncMaterialForm.marketingGoal = 'LIVE_PROM_GOODS'
      else this.syncMaterialForm.marketingGoal = 'VIDEO_PROM_GOODS'
      if (materialType !== 'VIDEO') this.syncMaterialForm.awemeId = ''
      else this.loadAwemeOptions()
    },
    syncCurrentMaterialType() {
      const form = this.syncMaterialForm
      if (!form.materialType) { this.$message.warning('请选择素材类型'); return }
      this.clearSyncPolling()
      this.resetSyncProgress()
      this.syncing = true
      this.syncState = 'QUEUED'
      const requestData = { advertiserId: this.advertiserId, materialType: form.materialType }
      let syncScope = 'ACCOUNT'
      if (form.materialType === 'VIDEO' && form.awemeId) {
        syncScope = 'AWEME_VIDEO'
        requestData.awemeId = form.awemeId
      }
      requestData.syncScope = syncScope
      request.post({
        url: '/oceanEngine/material/syncMaterialTask',
        data: requestData,
        loading: false,
        success: (res) => {
          if ((res.code === 0 || res.code === 1) && res.data && res.data.jobNo) {
            this.syncMaterialDialogVisible = false
            this.syncJobNo = res.data.jobNo
            this.syncState = res.data.state || 'QUEUED'
            this.syncPhase = res.data.phase || 'LIST_SYNC'
            this.$message.success(res.data.reused ? '已有当前类型同步任务正在执行' : '当前类型同步任务已提交')
            this.startSyncPolling()
          } else {
            this.syncing = false
            this.$message.error(res.msg || '统一素材同步任务提交失败')
          }
        },
        error: () => { this.syncing = false; this.$message.error('统一素材同步任务提交失败') }
      })
    },
    resetSyncProgress() {
      this.syncPageCount = 0
      this.syncSuccessCount = 0
      this.syncFailureCount = 0
    },
    startSyncPolling() {
      this.syncPollCount = 0
      this.pollSyncJob()
      this.syncPollTimer = setInterval(() => { this.pollSyncJob() }, 2000)
    },
    pollSyncJob() {
      if (!this.syncJobNo) return
      this.syncPollCount += 1
      if (this.syncPollCount > this.maxSyncPollCount) {
        this.syncing = false
        this.clearSyncPolling()
        this.$message.warning('同步任务仍在执行，请稍后手动查询素材')
        return
      }
      request.get({
        url: '/oceanEngine/material/syncJob',
        data: { jobNo: this.syncJobNo },
        loading: false,
        success: (res) => {
          if (res.code !== 0 && res.code !== 1) {
            this.syncing = false
            this.clearSyncPolling()
            this.$message.error(res.msg || '同步任务查询失败')
            return
          }
          const job = res.data || {}
          this.syncState = job.state || this.syncState
          this.syncPhase = job.phase || this.syncPhase
          const previousSuccessCount = this.syncSuccessCount
          this.syncPageCount = Number(job.pageCount || 0)
          this.syncSuccessCount = Number(job.successCount || 0)
          this.syncFailureCount = Number(job.failureCount || 0)
          if ((job.state === 'RUNNING' || job.state === 'QUEUED') && this.syncSuccessCount > previousSuccessCount) {
            this.loadMaterials()
          }
          if (job.state === 'SUCCESS') {
            this.syncing = false
            this.clearSyncPolling()
            this.$message.success(`同步完成，素材处理 ${job.successCount || 0} 条，详情/属性补全 ${job.processedCount || 0}/${job.totalCount || 0} 条`)
            this.loadMaterials()
          } else if (job.state === 'FAILED') {
            this.syncing = false
            this.clearSyncPolling()
            this.$message.error(job.errorSummary || '同步失败')
          }
        },
        error: () => { this.syncing = false; this.clearSyncPolling(); this.$message.error('同步任务查询失败') }
      })
    },
    clearSyncPolling() {
      if (this.syncPollTimer) {
        clearInterval(this.syncPollTimer)
        this.syncPollTimer = null
      }
    },
    clearUploadPolling() {
      if (this.uploadPollTimer) {
        clearInterval(this.uploadPollTimer)
        this.uploadPollTimer = null
      }
    },
    syncMaterialDetails() {
      if (!this.requireAdvertiser()) return
      if (!this.materialType) { this.$message.warning('请先选择需要补全详情的素材类型'); return }
      if (this.materialType !== 'VIDEO') { this.$message.warning('官方素材属性查询当前仅支持视频素材'); return }
      this.clearSyncPolling()
      this.resetSyncProgress()
      this.syncing = true
      this.syncState = 'QUEUED'
      this.syncPhase = 'DETAIL_ENRICH'
      request.post({
        url: '/oceanEngine/material/syncDetailTask',
        data: { advertiserId: this.advertiserId, materialType: this.materialType },
        loading: false,
        success: (res) => {
          if ((res.code === 0 || res.code === 1) && res.data && res.data.jobNo) {
            this.syncJobNo = res.data.jobNo
            this.syncState = res.data.state || 'QUEUED'
            this.syncPhase = res.data.phase || 'DETAIL_ENRICH'
            this.$message.success(res.data.reused ? '已有详情与属性补全任务正在执行' : '已提交批量详情与属性补全任务')
            this.startSyncPolling()
          } else {
            this.syncing = false
            this.$message.error(res.msg || '详情补全任务提交失败')
          }
        },
        error: () => { this.syncing = false; this.$message.error('详情补全任务提交失败') }
      })
    },
    syncImages(triggeredByPreview) {
      if (!this.requireAdvertiser()) return
      if (this.syncing) return
      this.clearSyncPolling()
      this.resetSyncProgress()
      this.syncing = true
      this.syncState = 'QUEUED'
      request.post({
        url: '/oceanEngine/material/syncImageTask',
        data: { advertiserId: this.advertiserId },
        loading: false,
        success: (res) => {
          if ((res.code === 0 || res.code === 1) && res.data && res.data.jobNo) {
            this.syncJobNo = res.data.jobNo
            this.syncState = res.data.state || 'QUEUED'
            this.syncPhase = res.data.phase || 'LIST_SYNC'
            if (triggeredByPreview) {
              this.$message.warning(res.data.reused ? '预览地址不可用，已有同步任务正在执行' : '预览地址不可用，已提交当前页素材同步任务')
            } else {
              this.$message.success(res.data.reused ? '已有同步任务正在执行' : '同步任务已提交')
            }
            this.startSyncPolling()
          } else {
            this.syncing = false
            this.$message.error(res.msg || '同步失败')
          }
        },
        error: () => { this.$message.error('官方图片同步任务提交失败'); this.syncing = false }
      })
    },
    openMaterialDetail(row) {
      if (!row || !row.id) return
      this.detailVisible = true
      this.detailLoading = true
      this.materialDetail = null
      request.get({
        url: '/oceanEngine/material/detail',
        data: { materialAssetId: row.id },
        loading: false,
        success: (res) => {
          this.detailLoading = false
          if (res.code === 0 || res.code === 1) { this.materialDetail = res.data || null }
          else this.$message.error(res.msg || '素材详情查询失败')
        },
        error: () => { this.$message.error('素材详情查询失败'); this.detailLoading = false }
      })
    },
    refreshUrl(row) {
      if (!row || !row.id || this.refreshing[row.id]) return
      this.$set(this.refreshing, row.id, true)
      request.post({
        url: '/oceanEngine/material/refreshImageUrl', data: { materialAssetId: row.id },
        success: (res) => {
          if ((res.code === 0 || res.code === 1) && res.data && res.data.officialUrl) {
            row.contentUrl = res.data.officialUrl
            this.loadMaterials()
            this.$message.success('已刷新官方预览地址，正在更新本地素材信息')
          } else {
            this.$message.warning((res.data && res.data.lastRefreshError) || res.msg || '官方预览地址暂不可用')
          }
          this.$set(this.refreshing, row.id, false)
        },
        error: () => { this.$message.error('刷新官方预览地址失败'); this.$set(this.refreshing, row.id, false) }
      })
    },
    openPreview(row) {
      if (!row) return
      this.previewMaterial = row
      this.videoCoverUnavailable = false
      this.previewVisible = true
    },
    openSensitiveAuthorizationGuide() {
      this.sensitiveAuthorizationVisible = true
    },
    isVideoRow(row) {
      return String((row && row.materialType) || '').toUpperCase() === 'VIDEO'
    },
    isImageRow(row) {
      return String((row && row.materialType) || '').toUpperCase() === 'IMAGE'
    },
    videoCoverUrl(row) {
      if (!row) return ''
      return row.coverUrl || row.posterUrl || row.poster_url || row.videoCoverUrl || row.video_cover_url || ''
    },
    videoCoverKey(row) {
      return String((row && (row.id || row.materialId || row.filename)) || '')
    },
    hasVideoCover(row) {
      return !!this.videoCoverUrl(row) && !this.videoCoverUnavailableByMaterial[this.videoCoverKey(row)]
    },
    handleVideoCoverLoadError(row) {
      this.$set(this.videoCoverUnavailableByMaterial, this.videoCoverKey(row), true)
    },
    handleVideoCoverError() {
      this.videoCoverUnavailable = true
    },
    handlePreviewError(row) {
      if (this.isImageRow(row)) this.syncCurrentPageWhenPreviewUnavailable(row)
    },
    syncCurrentPageWhenPreviewUnavailable(row) {
      if (!this.advertiserId || this.syncing) return
      const pageKey = `${this.advertiserId}:${this.pageIndex}:${this.pageSize}`
      if (this.shouldSkipPreviewSync(row)) {
        if (this.previewBlockedNoticePageKey !== pageKey) {
          this.previewBlockedNoticePageKey = pageKey
          this.$message.warning('该素材因所属主体与开发者主体不一致，无法获取 URL，已跳过自动同步')
        }
        return
      }
      if (this.previewSyncPageKey === pageKey) return
      this.previewSyncPageKey = pageKey
      this.syncImages(true)
    },
    shouldSkipPreviewSync(row) {
      const reason = String((row && row.previewSyncBlockedReason) || '').replace(/\s/g, '')
      const contentUrl = String((row && row.contentUrl) || '').replace(/\s/g, '')
      return this.isSubjectMismatchPreviewError(reason) || this.isSubjectMismatchPreviewError(contentUrl)
    },
    isSubjectMismatchPreviewError(value) {
      const reason = String(value || '').replace(/\s/g, '')
      return reason.indexOf('素材所属主体') >= 0 && reason.indexOf('开发者主体') >= 0 && reason.indexOf('无法获取URL') >= 0
    },
    isQianchuanVideoRow(row) {
      return this.isVideoRow(row) && String((row && row.materialChannel) || '').toUpperCase() === 'QIANCHUAN_VIDEO'
    },
    classificationTagItems(row) {
      if (!this.isQianchuanVideoRow(row)) return ['NOT_APPLICABLE']
      const tags = row && row.classificationTags
      if (!tags) return ['PENDING']
      const values = String(tags).split(',').map((item) => item.trim()).filter((item) => item)
      return values.length ? values : ['PENDING']
    },
    classificationTagText(tag) {
      const values = { INEFFICIENT: '低效素材', FIRST_PUBLISH: '首发素材', NORMAL: '正常素材', PENDING: '待同步', NOT_APPLICABLE: '不适用' }
      return values[tag] || '待同步'
    },
    classificationTagType(tag) {
      const values = { INEFFICIENT: 'warning', FIRST_PUBLISH: 'success', NORMAL: 'info', PENDING: 'info', NOT_APPLICABLE: 'info' }
      return values[tag] || 'info'
    },
    qualityText(level) {
      const values = { HIGH: '优质', GOOD: '良好', LOW: '低质', REJECTED: '不通过', UNKNOWN: '暂无质量结论' }
      return values[level] || '暂无质量结论'
    },
    qualityType(level) { return level === 'GOOD' || level === 'HIGH' ? 'success' : (level === 'LOW' || level === 'REJECTED' ? 'warning' : 'info') },
    materialTypeText(type) {
      const values = { IMAGE: '图片', CAROUSEL: '图文', LIVE_ROOM: '直播间画面', TITLE: '标题', VIDEO: '视频' }
      return values[type] || '未知类型'
    },
    materialSourceText(source) {
      const values = { ARTHUR: '亚瑟共享素材', CREATIVE_CENTER: '巨量创意PC共享素材', E_COMMERCE: '本地上传', LIVE_HIGHLIGHT: '直播剪辑素材', STAR: '星图&即合共享素材', TADA: 'tada共享素材', VIDEO_CAPTURE: '易拍APP共享素材', AGENT: '巨量方舟', JI_CHUANG: '即创共享素材', LEGACY_WORKBENCH: '旧版巨量引擎工作台共享素材' }
      return values[source] || (source || '官方未返回')
    },
    materialChannelText(channel) {
      const values = { QIANCHUAN_VIDEO: '千川视频素材', DOUYIN_VIDEO: '抖音视频素材', QIANCHUAN_CAROUSEL: '千川图文素材', DOUYIN_CAROUSEL: '抖音图文素材' }
      return values[channel] || '-'
    },
    materialSubtypeText(subtype) {
      const values = { IMAGE_SMALL: '横版小图', IMAGE_LARGE: '横版大图', IMAGE_VERTICAL: '竖版图片', IMAGE_PANORAMA_VERTICAL: '全景竖图', IMAGE_SQUARE: '方图', IMAGE_PRODUCT_SQUARE: '商品卡方图', IMAGE_PRODUCT_VERTICAL: '商品卡竖图', VIDEO_HORIZONTAL: '横版视频', VIDEO_VERTICAL: '竖版视频' }
      return values[subtype] || (subtype ? '其他类型' : '官方未返回')
    },
    uploadTypeText(type) {
      return type === 'IMAGE' ? '图片直传' : '视频直传'
    },
    uploadMaterialSpecText(spec) {
      const all = [...this.imageMaterialSpecs, ...this.videoMaterialSpecs]
      const found = all.find(item => item.code === spec)
      return found ? found.label : spec || '-'
    },
    uploadStateText(state) {
      const map = { UPLOADING: '上传中', OFFICIAL_PENDING: '处理中', SUCCESS: '已完成', FAILED: '失败' }
      return map[state] || state || '-'
    },
    uploadStateTagType(state) {
      const map = { UPLOADING: 'warning', OFFICIAL_PENDING: 'warning', SUCCESS: 'success', FAILED: 'danger' }
      return map[state] || 'info'
    },
    urlKindText(value) { return value === 'IMAGE' ? '图片预览' : (value === 'VIDEO' ? '视频地址' : (value || '未知')) },
    urlStateText(value) { return value === 'AVAILABLE' ? '可用' : (value === 'FAILED' ? '不可用' : '状态未知') },
    materialSyncStateText(state) {
      const values = { ACTIVE: '正常', INACTIVE: '已失效', UNKNOWN: '状态未知' }
      return values[state] || '状态未知'
    },
    assessmentTypeText(value) {
      const values = { CARRY_MATERIAL: '搬运素材', HIDDEN_WATERMARK: '暗水印', INEFFICIENT: '低效素材', AD_QUALITY: '广告质量', ECP_QUALITY: '千川质量', LOCAL_QUALITY: '本地质量', SIMILAR_MATERIAL: '同质化素材', FIRST_PUBLISH: '首发素材' }
      return values[value] || '官方评估'
    },
    assessmentGradeText(value) {
      const values = { HIGH: '优质', LOW: '低质', TRUE: '是', FALSE: '否', UNKNOWN: '官方未返回' }
      return values[value] || '官方未返回'
    },
    preauditStatusText(value) {
      const values = { PENDING: '审核中', PASS: '通过', REJECT: '驳回', SUCCESS: '通过', FAILED: '失败' }
      return values[value] || (value ? '官方状态' : '暂无结果')
    },
    dataSourceText(sources) {
      const values = { LOCAL_ASSET: '本地素材库', OFFICIAL_URL_SNAPSHOT: '官方地址快照', OFFICIAL_ASSESSMENT: '官方评估', OFFICIAL_VIOLATION: '官方违规', OFFICIAL_PREAUDIT: '官方预审', LOCAL_UPLOAD_TASK: '本地上传任务' }
      const list = Array.isArray(sources) ? sources : []
      return list.length ? list.map((item) => values[item] || '未知来源').join('、') : '本地素材库'
    },
    dataStatusText(status) {
      if (!status) return '未请求同步'
      if (typeof status === 'string') return status
      let text = status.message || '未请求同步'
      if (status.errorSummary) text += `：${status.errorSummary}`
      if (status.lastAttemptAt) text += `（最近尝试：${status.lastAttemptAt}）`
      return text
    },
    formatDuration(millis) {
      const totalSeconds = Math.max(0, Math.floor(Number(millis || 0) / 1000))
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = totalSeconds % 60
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    },
    formatFileSize(bytes) {
      const value = Number(bytes || 0)
      if (!value) return '-'
      if (value < 1024) return `${value} B`
      if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`
      return `${(value / (1024 * 1024)).toFixed(1)} MB`
    },
    isSafeExternalUrl(url) {
      return /^https?:\/\//i.test(String(url || ''))
    },
    canOpenVideoPageForRow(row) {
      return this.isSafeExternalUrl(row && row.contentUrl)
    },
    openVideoPage(row) {
      const url = row && row.contentUrl
      if (!this.isSafeExternalUrl(url)) {
        this.$message.warning('官方未返回可跳转的视频作品地址')
        return
      }
      const popup = window.open(url, '_blank', 'noopener,noreferrer')
      if (popup) popup.opener = null
    }
  }
}
</script>

<style scoped lang="less">
// —— 抖川助手 浅蓝白设计令牌 ——
@primary-blue: #3b82f6;
@primary-hover: #2563eb;
@bg-pale: #eff6ff;
@border-soft: #dbeafe;
@text-slate-800: #1e293b;
@text-slate-600: #475569;
@text-slate-400: #94a3b8;

.qy-material-manage-page {
  padding: 16px;
  background-color: #f0f5ff;
  min-height: 100vh;
}

.dc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef2f7;

  .dc-toolbar__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
}

.dc-filter-bar {
  background: @bg-pale;
  border: 1px solid @border-soft;
  border-radius: 8px;
  padding: 12px 16px 0;
  margin-bottom: 16px;

  .dc-filter-form {
    .el-form-item {
      margin-bottom: 12px;
    }
  }
}

.dc-section-card {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.06);
}

// —— 网格 Grid 样式 ——
.material-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.material-grid-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  transition: all 0.2s ease;
  &:hover {
    border-color: @primary-blue;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.12);
  }

  .material-grid-card__cover {
    position: relative;
    width: 100%;
    height: 150px;
    background: #f8fafc;
    cursor: pointer;
    overflow: hidden;

    .cover-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .empty-cover {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: @text-slate-400;
      font-size: 13px;

      &.blocked {
        color: #f59e0b;
        padding: 8px;
        text-align: center;
      }
    }

    .play-icon-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 32px;
      color: rgba(255, 255, 255, 0.9);
      pointer-events: none;
    }

    .duration-badge {
      position: absolute;
      bottom: 6px;
      right: 6px;
      background: rgba(15, 23, 42, 0.75);
      color: #ffffff;
      font-size: 11px;
      padding: 2px 6px;
      border-radius: 4px;
    }

    .card-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(30, 41, 59, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    &:hover .card-overlay {
      opacity: 1;
    }
  }

  .material-grid-card__info {
    padding: 10px 12px;

    .title-line {
      font-size: 13px;
      font-weight: 600;
      color: @text-slate-800;
      margin-bottom: 4px;
    }

    .meta-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: @text-slate-400;
      margin-bottom: 6px;
    }

    .tags-line {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
    }
  }
}

// —— 表格 Table 样式 ——
.dc-compact-table {
  width: 100%;

  .table-preview-box {
    position: relative;
    width: 60px;
    height: 60px;
    margin: 0 auto;
    cursor: pointer;
    overflow: hidden;
    border-radius: 4px;
  }

  .table-thumb {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
  }

  .table-thumb-empty {
    width: 60px;
    height: 60px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @text-slate-400;
    border-radius: 4px;
  }

  .table-play-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-size: 20px;
  }

  .table-blocked-text {
    font-size: 11px;
    color: #f59e0b;
  }
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.sub-tip {
  font-size: 12px;
  color: @text-slate-400;
  line-height: 1.4;
  margin-top: 4px;
}

.image-crop-preview-box {
  width: 100%;
  height: 320px;
  background: #f8fafc;
  border: 1px dashed @border-soft;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .crop-img-element {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.task-guide-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  background: @bg-pale;
  border: 1px solid @border-soft;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  color: @text-slate-600;
  margin-bottom: 12px;
}

.task-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.auth-guide-content {
  padding: 12px 0;
  font-size: 14px;
  color: @text-slate-800;
  line-height: 1.6;

  .auth-highlight {
    font-weight: 600;
    color: @primary-blue;
    font-size: 16px;
    margin: 8px 0;
  }

  .auth-link {
    color: @primary-blue;
    text-decoration: underline;
  }
}

.preview-dialog-body {
  display: flex;
  gap: 16px;

  .preview-media-wrap {
    width: 320px;
    height: 320px;
    background: #f1f5f9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .preview-img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .empty-text {
      color: @text-slate-400;
      font-size: 13px;
      padding: 12px;
      text-align: center;
    }
  }

  .preview-meta-info {
    flex: 1;
    font-size: 13px;
    color: @text-slate-800;
    line-height: 1.8;
  }
}

.detail-drawer-content {
  padding: 16px;

  .detail-block {
    margin-bottom: 20px;

    h4 {
      margin: 0 0 10px;
      font-size: 15px;
      font-weight: 600;
      color: @text-slate-800;
      border-left: 3px solid @primary-blue;
      padding-left: 8px;
    }

    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px 16px;
      font-size: 13px;
      color: @text-slate-600;

      span {
        color: @text-slate-400;
      }
    }

    .detail-empty {
      font-size: 13px;
      color: @text-slate-400;
      padding: 8px 0;
    }
  }
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
